import { TranslateService } from '@ngx-translate/core';
import { Moment } from 'moment';

import { TabInfoBase } from 'app/buffer-graph/models/tab-info-base';
import { BufferChangeReason } from 'app/buffer-graph/models/buffer-change-reasons/buffer-change-reason';

type Data = { reasons: BufferChangeReason[], startDate: Moment, endDate?: Moment };

export class BufferChangeReasonsTabInfo extends TabInfoBase<Data> {
    constructor(data: Data) {
        super(data.endDate ? `${data.startDate.format('L')} - ${data.endDate.format('L')}` : data.startDate.format('L'), data);
    }

    get id(): string {
        return BufferChangeReasonsTabInfo.id;
    }

    static readonly id = 'BCR';
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/buffer-change-reasons/buffer-change-reasons-tab-info.ts